
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gcGsU7u9H_45l5mzld9Tvnz0CgOtdZ_45DijSXDtNTswQUKUMeta } from "/codebuild/output/src25092165/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexRQyLxyOKaRdb2xlGh8kyvqZZbt27L3DJikj80ssx_m8Meta } from "/codebuild/output/src25092165/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchvs4WNPix9_YzPIc9XrQgRyq8xjuCMsq7bZ18EPD3fEsMeta } from "/codebuild/output/src25092165/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as index6RkUwpoBHYDK_452QfWIMivbp5cPLQ4RfDgKaAqSaquZsMeta } from "/codebuild/output/src25092165/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93164d7nRBdIih6Dng4IHziHBWZ8Aa1ddcSvQfPl30zqwMeta } from "/codebuild/output/src25092165/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexJRevkL_Snr8F9BBpcB2of1_tC8K7ZeOkBmmIdSdBKAMMeta } from "/codebuild/output/src25092165/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93kofnET0GnLoVXo0oNgR_45bYFBtGCkkvCFYQArmdheQYwMeta } from "/codebuild/output/src25092165/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexluoE9i3qQrM7mfFg35Po0TZyTMC8FUUuIOC53NgmAvcMeta } from "/codebuild/output/src25092165/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93VlzmXEtwaiwOoc1vgeq2t24J0bAIWNBp7Lxwt3yp11YMeta } from "/codebuild/output/src25092165/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indextxQqRjPopuGG2a8pnqfNA01M2STkmNGMObAqKu0XtskMeta } from "/codebuild/output/src25092165/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexguij34tpkYvQYjuxXw1vMt_JsHx6PqSTGxi9LDvMWggMeta } from "/codebuild/output/src25092165/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src25092165/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src25092165/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src25092165/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src25092165/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src25092165/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexJRevkL_Snr8F9BBpcB2of1_tC8K7ZeOkBmmIdSdBKAMMeta || {},
    component: () => import("/codebuild/output/src25092165/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src25092165/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexluoE9i3qQrM7mfFg35Po0TZyTMC8FUUuIOC53NgmAvcMeta || {},
    component: () => import("/codebuild/output/src25092165/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src25092165/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indextxQqRjPopuGG2a8pnqfNA01M2STkmNGMObAqKu0XtskMeta || {},
    component: () => import("/codebuild/output/src25092165/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexguij34tpkYvQYjuxXw1vMt_JsHx6PqSTGxi9LDvMWggMeta || {},
    component: () => import("/codebuild/output/src25092165/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]